





































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Contacts extends Vue { 
    @Prop(Object) readonly tableItem: any
    @Prop(String) readonly cloumnName: any
	@Prop() public trackid: any
    
    menu = false

	get dateText() {
      	if (this.tableItem[`${this.cloumnName}`]) {
			const [year, month, day] = this.tableItem[`${this.cloumnName}`].split("-")
			return `${day}/${month}/${year}`
		}
		return this.tableItem[`${this.cloumnName}`]
    }

	set dateText (newValue: any) {
		this.tableItem[`${this.cloumnName}`] = newValue === null ? "" : newValue
	}
}
